import type { MotnMovie, MotnSeries } from '@setplex/tria-api'

import {
  compressToEncodedURIComponent,
  decompressFromEncodedURIComponent,
} from 'lz-string'
import { addQuery } from '~/shared/routes'

export type MotnItem = MotnMovie | MotnSeries

export const compressMotnItem = (item: MotnItem): string => {
  // Omit imageUrl and imageHorizontalUrl from the hash to avoid long hashes
  // because they are not needed for details page
  const { imageUrl: _unused1, imageHorizontalUrl: _unused2, ...rest } = item
  const json = JSON.stringify(rest)
  return compressToEncodedURIComponent(json)
}

export const decompressMotnItem = (data: string): MotnItem | null => {
  try {
    const json = decompressFromEncodedURIComponent(data)
    if (!json) return null
    return JSON.parse(json) as MotnItem
  } catch {
    return null
  }
}

export const buildMotnLink = (
  item: MotnItem,
  params?: { routeName?: string; categoryName?: string }
): string => {
  const compressed = compressMotnItem(item)
  const base = '/content/motn'
  const withQuery = params ? addQuery(base, params) : base
  return `${withQuery}#${compressed}`
}
